export const deClientPortalLayoutPages = {
    layout: {
        navigation: {
            dashboard: 'Übersicht',
            inbox: 'Inbox',
            profile: 'Profil',
        },
    },
}
